import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'shared-filter-panel',
  templateUrl: 'filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss'],
  host: { class: 'filter-panel' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelComponent {
  @Input() disableSpacer = false;
}
